import AuthService from '../../service/auth';
import StorageService from '../../service/storage';
import AppSettings from '../../settings/app-settings';
import {Api, AppRouters} from '../../settings';
import http from '../../service/api';
import {
    expirationTimeout,
    isSuccessResponse,
    marketingProfilePayload,
    pickProfileResponse,
    profilePayload,
    toastHelper
} from '../../shared';
import {navigate} from '@reach/router';
import {pickUserResponse} from '../../hooks/Auth';
import {AuthEvents} from './auth.events';
import {reduxEventBusDispatcher} from '../_common/actions';
import {toReduxStore} from "./profile.adapter";

export const loginAction = (payload) => ({type: 'SIGN_IN_USER', payload});
export const refreshExpirationTokenAction = () => ({type: 'REFRESH_EXPIRATION_TOKEN'});
export const authPatchStateAction = (payload) => ({type: 'AUTH_PATCH_STATE', payload});

export const invalidateUserAction = (
    payload = {
        isAuthenticated: false,
        user: null,
        profile: null,
        ticket: null,
        expirationToken: undefined
    }
) => {
    return async (dispatch) => {
        StorageService.removeItem(AppSettings.ticketName);
        dispatch({type: 'INVALIDATE_USER', payload});
    }
};

export const logoutAction = (navigateTo = AppRouters.home) => {
    return async (dispatch) => {
        try {
            await AuthService.signOut();
        } finally {
            StorageService.removeItem(AppSettings.ticketName);
            dispatch(invalidateUserAction());
            dispatch(reduxEventBusDispatcher(AuthEvents.signOut));
            await navigate(navigateTo);
        }
    };
};

export const authenticateAction = () => {
    return async (dispatch) => {
        try {
            const userResp = await http.get(Api.userInfo);
            if (isSuccessResponse(userResp, false)) {
                const user = pickUserResponse(userResp);
                const profileResp = await http.get(Api.fetchProfile(user.unique_id), {target: 'alf'});

                if (isSuccessResponse(profileResp)) {
                    const pulledProfile = pickProfileResponse(profileResp) || {email: user.email};
                    dispatch(
                        authPatchStateAction({
                            isAuthenticated: true,
                            user,
                            expirationToken: expirationTimeout(),
                            profile: pulledProfile
                        })
                    );
                    return;
                }
            }
        } catch (e) {
            console.log(e)
        }

        toastHelper.error('No pudimos autenticarte. Ocurrió un error al verificar el ticket de autenticación.');
        dispatch(logoutAction());
        dispatch(invalidateUserAction());
    };
};

export const fetchProfileAction = () => {
    return async (dispatch, getState) => {

        const state = getState();
        const user = state?.authReducers?.user;
        const profile = state?.authReducers?.profile;
        if (profile || !user || !user?.unique_id) return;

        try {
            const response = await http.get(Api.fetchProfile(user.unique_id), {target: 'alf'});
            if (isSuccessResponse(response)) {
                const pulledProfile = pickProfileResponse(response) || {email: user.email};
                dispatch(authPatchStateAction({profile: pulledProfile}));
                return;
            }
        } catch (e) {
            console.log(e)
        }

        dispatch(authPatchStateAction({profile: {email: user?.email}}));
    };
};

export const saveProfileAction = (payload) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const user = state?.authReducers?.user;
            if (!user || !user?.unique_id) return;

            const profileData = profilePayload(payload);
            const respProfileDataAction = await http.post(Api.saveProfile(user.unique_id), {profile: profileData}, {target: 'alf'});
            // const respMarketingDataAction = await http.put(Api.saveMarketingUserData, marketingProfilePayload(payload));

            if (isSuccessResponse(respProfileDataAction)) {
                dispatch(authPatchStateAction({
                    user: {...toReduxStore(profileData), unique_id: user.unique_id},
                    profile: profileData
                }));
                toastHelper.success('Sus datos fueron actualizados correctamente.');
                await navigate(AppRouters.myReports);
            }

            // if (!isSuccessResponse(respMarketingDataAction)) {
            //     console.log('Profile Error while Saving User Marketing Data');
            // }
            return;
        } catch (e) {
            console.log(e)
        }

        toastHelper.showGenericErrorMessage();
    };
};

